import React from 'react';
import { socialLinks } from '../../../config/socialLinks';

const SocialLinksRow = () => {
  if (socialLinks.length === 0) return null;

  return (
    <div className="flex items-center justify-center gap-4 sm:gap-6 mb-12 lg:mb-16">
      {socialLinks.map(({ platform, url, label, Icon }) => (
        <a
          key={platform}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Follow OpenbooQ on ${label}`}
          className="p-3 rounded-lg text-[#000150] hover:text-[#07B0E9] hover:scale-110 transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#07B0E9]"
        >
          <Icon className="w-7 h-7 lg:w-8 lg:h-8" aria-hidden="true" />
        </a>
      ))}
    </div>
  );
};

export default SocialLinksRow;
